<template>
    <div class="row mx-0 h-100m370px">
        <div class="col-md-12 main-content">
            <div class="d-flex justify-content-between">
                <h1 class="first-header heading-large"><i class="fas fa-file-signature mr-2"></i>Contracts</h1>
                <refresh-information />
            </div>
            <div 
                class="table-container card"
                :class="{'px-3' : $breakpoint.mdAndDown}"
            > 
                <div class="table-title"></div>
                <div v-if="!contracts || contracts.length < 1" class="w-100 alert alert-secondary mt-3 text-center">
                    <i class="fas fa-info-circle mr-2"></i>No contracts found                             
                </div>
                <table v-else class="table responsive-table">
                    <thead>  
                        <tr>
                            <th> Contract Ref </th>
                            <th> Product </th>
                            <th> Terminal/Network </th>
                            <th> Seller </th>
                            <th class="text-right"> Total Vol/L </th>
                            <th>      </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(contract, key) in contracts" :key="key">
                            <td label="Contract Ref"> 
                                <span>
                                    <button class="btn btn-link" @click="openContractReportModal(contract)">
                                        {{contract.contract.reference}}
                                    </button>
                                </span>
                            </td>
                            <td label="Product">  
                                <span>{{contract.fuel_id | fueltype}}</span>
                            </td>
                            <td label="Terminal/Network"> 
                                <span> {{contract.location}}</span>
                            </td>
                            <td label="Seller"> 
                                <span> {{contract.sellerName}}</span>
                            </td>
                            <td label="Total Vol/L" class="text-right"> 
                                <span> {{contract.contract.totalQuantity | volumeformat}} </span>
                            </td>
                            <td class="text-right td-actions">
                                <button class="btn btn-icon text-secondary" @click="openContractReportModal(contract)">
                                    <i class="fas fa-chart-pie fa-lg"> </i>
                                </button>
                            </td>
                        </tr>
                    </tbody> 
                </table>
            </div>

            <contract-report v-if="showContractReport" v-bind:selectedContract="selectedContract"  v-on:hideContractReport='hideContractReport'/>
        </div>            
    </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import RefreshInformation from '@/components/RefreshInformation.vue'
import ContractReport from '@/modals/ContractReport.vue'
import breakpoint from '@/mixins/index';
import { populateContractDetails } from '@/util/contracts.js';

export default {
    mixins: [breakpoint],
    data(){
        return {
            supplierList: [],
            selectedContract: {},
            showContractReport: false
        }
    },
    components:{
        ContractReport,
        RefreshInformation
    },
    created() {
            this.getRelationships();
    },
    computed: {
        ...mapGetters('offers', ['getLiveContracts', 'getHasExistingContracts']),
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapGetters('accounts', ['getSuppliersChanges']),
        ...mapGetters('terminals', ['getTerminalChanges']),
        ...mapGetters('login', ['getAccountType']),
        ...mapGetters('metadata', ['networkConfig']),
        contracts: {
            get: function () {
                let contractList = [];

                if (this.networkConfig){
                    contractList = this.getLiveContracts
                        .map(this.namesFromIds)
                        .filter(contract => contract.type_id === "TRACKING");
                }

                return contractList;
            }
        }
    },
    methods:{
        ...mapActions('accounts', ['getRelationships']),
        namesFromIds(contract){
                    if(contract.terminal_id != null){
                        const terminal = this.getTerminalChanges.find(t => t._id === contract.terminal_id);
                        contract.location = terminal ? terminal.name : "N/A";
                    } else{
                        contract.location = contract.networkId === this.networkConfig.UkFuelsId ? "UK Fuels" : "Keyfuels";
                    }
                    const seller = this.getSuppliersChanges.find(s => s.id === contract.account_id.toString());
                    contract.sellerName = seller ? seller.name : "--";

                    return contract; 
        },
        openContractReportModal: async function(contract){
            this.selectedContract = populateContractDetails(contract, "LIVE_CONTRACT");
            this.showContractReport = true;
        },
        hideContractReport(){
            this.showContractReport = false;
        },
    }
}
</script>